import React, { useState } from "react";
import styled from "styled-components";
import GlobalStyle, { Blue, SecondaryColor } from "../styles/global";
import SelecionarMoedasAdm from "../components/SelecionarMoedasAdm";
import Confirmacao from "../components/Confirmacao";
import { Container } from "../styles/styles";
import { ContentSection, Content } from "../styles/styles";
import { API_URL } from "../controllers/api";
import SelecionarEmocionadorAdm from "../components/SelecionarEmocionadorAdm";

const BackBar = styled(Container)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 60px;
  max-width: 100%;
`;

const LoadingSpinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4CAF50;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  color: #666;
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
`;

// Componente de Loading
const LoadingComponent = ({ message = "Processando..." }) => (
  <Container direction="column" width="100%">
    <ContentSection fullWidth padding="10px">
      <Content padding="40px" style={{ textAlign: 'center' }}>
        <LoadingSpinner />
        <LoadingText>{message}</LoadingText>
      </Content>
    </ContentSection>
  </Container>
);

function Distribuir({ onClose }) {
  const [step, setStep] = useState(1);
  const [emocionador, setEmocionador] = useState(null);
  const [moedas, setMoedas] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [moedasADistribuir, setMoedasADistribuir] = useState(0);
  const [loading, setLoading] = useState(false); // Estado de loading
  const user = JSON.parse(localStorage.getItem("user"));

  const handleSelectEmocionador = (selectedEmocionador) => {
    setEmocionador(selectedEmocionador);

    const moedas = selectedEmocionador.moedas_a_distribuir
      ? JSON.parse(selectedEmocionador.moedas_a_distribuir)
      : 0;
    setMoedasADistribuir(moedas);

    localStorage.setItem("moedasADistribuir", JSON.stringify(moedas));

    setStep(2);
  };
  const handleConfirmMoedas = async (moedas, moedasType) => {
  setMoedas(moedas);

  try {
    const response = await fetch(`${API_URL}/distribuirMoedas`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        distribuidorId: user.idusuario,
        receptorId: emocionador.id,
        data: new Date(),
        moedas,
        tipo_moeda: moedasType, // Adiciona o tipo de moeda
      }),
    });

    const result = await response.json();

    if (response.ok) {
      setStep(3); 
    } else {
      setErrorMessage(
        result.mensagem || "Ocorreu um erro ao enviar os dados."
      );
    }
  } catch (error) {
    setErrorMessage(`Erro de comunicação com a API: ${error.message}`);
  }
};

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleClose = () => {
    window.location.href = "/";
  };

  return (
    <>
      <GlobalStyle />
      <Container
        bgColor="#fff"
        fullWidth
        direction="column"
        align="center"
        justify="center"
        padding="0px"
      >
        {loading ? (
          <LoadingComponent message="Distribuindo moedas..." />
        ) : (
          <>
            {step === 1 && (
              <SelecionarEmocionadorAdm
                onSelect={handleSelectEmocionador}
                onClose={handleClose}
              />
            )}
            {step === 2 && (
              <SelecionarMoedasAdm
                emocionador={emocionador}
                onConfirm={handleConfirmMoedas}
                onBack={handleBack}
                errorMessage={errorMessage}
                onClose={handleClose}
              />
            )}
            {step === 3 && (
              <Confirmacao
                emocionador={emocionador}
                moedas={moedas}
                onClose={handleClose}
              />
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default Distribuir;